<template>
  <router-view />
</template>

<script>
export default {
  computed: {
    showHeader () {
      if (this.$store.state.onboarding.isOnboarding) {
        return false
      }

      return false
    }
  }
}
</script>
